import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';
import breakpoints from 'utils/breakpoints';
import SearchCard from 'components/components/molecules/SearchCard';
import cx from 'classnames';
import { Placeholder } from '@sitecore-jss/sitecore-jss-react';
import { hasPrice, parsePrice } from 'utils/parsePrice';
import { usePrevious } from 'react-use';
import useBreakpoint from 'utils/hooks/useBreakpoint';
import useMetroSearchMarketPromotionCard from 'utils/hooks/useMetroSearchMarketPromotionCard';
import PromotionSearchCard from '../PromotionSearchCard';

const SearchTitle = styled.h2`
  letter-spacing: -0.46px;
  @media ${breakpoints.md} {
    letter-spacing: -0.5px;
    line-height: 2.625rem;
  }
`;

const SearchSubtitle = styled.div`
  letter-spacing: 0.11px;
  line-height: 28px;
`;

const formatSitecoreDate = (dateString) => {
  return (
    dateString.substr(0, 4) +
    '-' +
    dateString.substr(4, 2) +
    '-' +
    dateString.substr(6, 2)
  );
};
const ListContainer = ({ children, trigger }) => {
  const ref = useRef();
  const prevTrigger = usePrevious(trigger);

  useEffect(() => {
    if (ref.current && prevTrigger !== trigger) {
      ref.current.classList.remove(
        'opacity-1',
        'translate-y-0',
        'transition-all',
        'duration-500',
      );
      ref.current.classList.add('opacity-0', 'translate-y-10');
      setTimeout(() => {
        if (ref.current) {
          ref.current.classList.add(
            'opacity-1',
            'translate-y-0',
            'transition-all',
            'duration-500',
          );
          ref.current.classList.remove('opacity-0', 'translate-y-10');
        }
      }, 300);
    }
  }, [trigger]);

  return (
    <div ref={ref} className='transform'>
      {children}
    </div>
  );
};

const extractSize = (value) => {
  let cleanValue = value && value.replace(',', '');
  return parseFloat(cleanValue);
};
const sortByTitle = (cards) => {
  return [...cards].sort((a, b) =>
    a.title.toLowerCase() > b.title.toLowerCase() ? 1 : -1,
  );
};
const sortByPrice = (cards) => {
  return [...cards].sort((at, bt) => {
    let a = at;
    let b = bt;
    // if (at.type === "MPC") a = at.communityCards[0];
    // if (bt.type === "MPC") b = bt.communityCards[0];
    let aPrice = '0';
    let bPrice = '0';
    if (a) aPrice = parsePrice(a.price.price === '' ? '0' : a.price.price);
    else return -1;
    if (b) bPrice = parsePrice(b.price.price === '' ? '0' : b.price.price);
    else return 1;
    return aPrice === bPrice
      ? a.title.toLowerCase() > b.title.toLowerCase()
        ? 1
        : -1
      : aPrice > bPrice
      ? 1
      : -1;
  });
};
const sortByDate = (cards) => {
  return [...cards].sort((a, b) => {
    let dateA = new Date(a.date);
    let dateB = new Date(b.date);

    if (isNaN(dateA.getTime())) {
      dateA = new Date(formatSitecoreDate(a.date));
    }
    if (isNaN(dateB.getTime())) {
      dateB = new Date(formatSitecoreDate(b.date));
    }

    if (isNaN(dateA.getTime()) || isNaN(dateB.getTime())) {
      if (isNaN(dateA.getTime()) && !isNaN(dateB.getTime())) {
        return 1;
      }
      if (isNaN(dateB.getTime()) && !isNaN(dateA.getTime())) {
        return -1;
      }
      return a.title.toLowerCase() < b.title.toLowerCase() ? 1 : -1;
    }

    if (dateA - dateB === 0) {
      return a.title.toLowerCase() > b.title.toLowerCase() ? 1 : -1;
    }
    return dateA < dateB ? -1 : 1;
  });
};
const datetoString = (dateString) => {
  if (dateString) {
    if (dateString && dateString.includes('/')) {
      return dateString.substr(6, 4) + dateString.substr(0, 2);
    } else return dateString.substr(0, 4) + dateString.substr(4, 2);
  }
  return '';
};
const isReadyNow = (availableDateMessage) => {
  if (availableDateMessage) {
    const splitLen = availableDateMessage.split(' ').length;
    return splitLen < 3;
  }
  return false;
};

const sortByFlagDate = (cards, country) => {
  return [...cards].sort((a, b) => {
    let dateA = datetoString(a.date);
    let dateB = datetoString(b.date);

    const availableMessageA = a.availableDateMessage;
    const availableMessageB = b.availableDateMessage;
    const hasQSLA = a.preSellingHome && a.countryQMI === 'United States';
    const hasQSLB = b.preSellingHome && b.countryQMI === 'United States';

    if (isReadyNow(availableMessageA) || isReadyNow(availableMessageB)) {
      if (isReadyNow(availableMessageA) && !isReadyNow(availableMessageB)) {
        return -1;
      }
      if (isReadyNow(availableMessageB) && !isReadyNow(availableMessageA)) {
        return 1;
      }
      return a.title.toLowerCase() > b.title.toLowerCase() ? 1 : -1;
    }
    if (country === 'USA') {
      if (hasQSLA || hasQSLB) {
        if (hasQSLA && !hasQSLB) {
          return 1;
        }
        if (hasQSLB && !hasQSLA) {
          return -1;
        }
        return a.title.toLowerCase() > b.title.toLowerCase() ? 1 : -1;
      }

      if (dateA === '' || dateB === '') {
        if (dateA && dateB === '') {
          return 1;
        }
        if (dateB && dateA === '') {
          return -1;
        }
        return a.title.toLowerCase() < b.title.toLowerCase() ? 1 : -1;
      }
    } else {
      if (dateA === '' || dateB === '') {
        if (dateA && dateB === '') {
          return -1;
        }
        if (dateB && dateA === '') {
          return 1;
        }
        return a.title.toLowerCase() < b.title.toLowerCase() ? 1 : -1;
      }
    }

    if (
      (isReadyNow(a.availableDateMessage) &&
        isReadyNow(b.availableDateMessage)) ||
      dateA === dateB
    ) {
      return a.title.toLowerCase() > b.title.toLowerCase() ? 1 : -1;
    }
    return dateA < dateB ? -1 : 1;
  });
};

const sortByPlans = (cards) => {
  const withNoPrice = cards
    .filter((c) => !hasPrice(c.price && c.price.price))
    .sort((a, b) => {
      return a.title.toLowerCase() > b.title.toLowerCase() ? 1 : -1;
      /* const aHomeType = a.homeType ? a.homeType : "";
      const bHomeType = b.homeType ? b.homeType : "";
      return aHomeType === bHomeType
        ? a.title.toLowerCase() > b.title.toLowerCase()
          ? 1
          : -1
        : aHomeType > bHomeType
        ? 1
        : -1;*/
    });
  // console.log({ withNoPrice });
  const withPrice = sortByPrice(
    cards.filter((c) => hasPrice(c.price && c.price.price)),
  );
  return [...withPrice, ...withNoPrice];
};
const isMPCwithQMI = (mpc) => {
  if (mpc && mpc.communityCards && mpc.communityCards.length > 0) {
    for (let i = 0; i < mpc.communityCards.length; i++) {
      if (
        mpc.communityCards[i] &&
        mpc.communityCards[i].qmi &&
        mpc.communityCards[i].qmi.length
      ) {
        return true;
      }
    }
  }
  return false;
};
const sortByAvailability = (cards) => {
  // console.log({ cards });
  const cardsWithQMIs = cards.filter((e) =>
    e.type === 'MPC' ? isMPCwithQMI(e) : e.qmi && e.qmi.length > 0,
  );
  const withQMINoPrice = cardsWithQMIs
    .filter((c) => !hasPrice(c.price && c.price.price))
    .sort((a, b) => {
      const aActive = a.feedFileStatus && a.feedFileStatus === 'Active' ? 1 : 0;
      const bActive = b.feedFileStatus && b.feedFileStatus === 'Active' ? 1 : 0;
      return aActive === bActive
        ? a.title.toLowerCase() > b.title.toLowerCase()
          ? 1
          : -1
        : aActive > bActive
        ? 1
        : -1;
    });
  const withQMIPrice = cardsWithQMIs.filter((c) =>
    hasPrice(c.price && c.price.price),
  );
  const sortByPriceQMIs = sortByPrice(withQMIPrice);

  const cardsWithNoQMIs = cards.filter((e) =>
    e.type === 'MPC' ? !isMPCwithQMI(e) : !(e.qmi && e.qmi.length > 0),
  );
  const withNoQMINoPrice = cardsWithNoQMIs
    .filter((c) => !hasPrice(c.price && c.price.price))
    .sort((a, b) => {
      const aActive = a.feedFileStatus && a.feedFileStatus === 'Active' ? 1 : 0;
      const bActive = b.feedFileStatus && b.feedFileStatus === 'Active' ? 1 : 0;
      return aActive === bActive
        ? a.title.toLowerCase() > b.title.toLowerCase()
          ? 1
          : -1
        : aActive > bActive
        ? 1
        : -1;
    });
  const withNoQMIPrice = cardsWithNoQMIs.filter((c) =>
    hasPrice(c.price && c.price.price),
  );
  const sortByPriceNoQMIs = sortByPrice(withNoQMIPrice);

  /* console.log({
    sortByPriceQMIs,
    withQMINoPrice,
    sortByPriceNoQMIs,
    withNoQMINoPrice,
  });*/

  return [
    ...sortByPriceQMIs,
    ...withQMINoPrice,
    ...sortByPriceNoQMIs,
    ...withNoQMINoPrice,
  ];
};

const sortByCustom = (cardsToSort, idList) => {
  //console.log({ cardsToSort, idList });
  /*
  Only ids on the list
  const map = new Map(cardsToSort.map((card) => [card.id, card]));
  return idList.map((id) => map.get(id)).filter(Boolean);
  */

  if (!Array.isArray(idList)) return cardsToSort;

  if (!Array.isArray(cardsToSort)) return [];

  // id -> position on idList
  const orderMap = new Map(idList.map((id, index) => [id, index]));

  return [...cardsToSort].sort((a, b) => {
    const indexA = orderMap.get(a.id);
    const indexB = orderMap.get(b.id);

    // Both index are on the list, order by index
    if (indexA !== undefined && indexB !== undefined) {
      return indexA - indexB;
    }

    // Only A is on the list → A first
    if (indexA !== undefined) return -1;

    // Only B is on the list → B first
    if (indexB !== undefined) return 1;

    // None index are on the list
    return 0;
  });
};

const sortResults = (cards, sortBy, productType, country, idList) => {
  switch (sortBy) {
    case 'title':
      return sortByTitle(cards);
    case 'price':
      return sortByPlans(cards); // return sortByPrice(cards);
    case 'size':
      return [...cards].sort((a, b) => {
        const aSizeAttr = a.attributes
          .find((a) => a.icon === 'ruler')
          .label.split('-')[0];
        const bSizeAttr = b.attributes
          .find((a) => a.icon === 'ruler')
          .label.split('-')[0];

        if (aSizeAttr && bSizeAttr) {
          const aSize = extractSize(aSizeAttr);
          const bSize = extractSize(bSizeAttr);

          if (aSize === bSize) {
            const aMaxSizeAttr = a.attributes
              .find((a) => a.icon === 'ruler')
              .label.split('-')[1];
            const bMaxSizeAttr = b.attributes
              .find((a) => a.icon === 'ruler')
              .label.split('-')[1];
            const aMaxSize = extractSize(aMaxSizeAttr);
            const bMaxSize = extractSize(bMaxSizeAttr);
            return aMaxSize > bMaxSize ? 1 : -1;
          }

          return aSize > bSize ? 1 : -1;
        }
      });
    case 'date':
      return sortByDate(cards);
    case 'availability':
      return sortByAvailability(cards);
    case 'custom':
      return sortByCustom(cards, idList);
    default:
      if (productType === 'plan') return sortByPlans(cards);
      else if (productType === 'qmi') return sortByFlagDate(cards, country);
      else return sortByTitle(cards);
  }
};

const getMPCsAndCommunities = (cards, filterCards) => {
  let MPCCards = [...filterCards];
  if (MPCCards.length > 0) {
    for (let i = 0; i < MPCCards.length; i++) {
      MPCCards[i].communityCards = [];
    }
    for (let i = 0; i < cards.length; i++) {
      if (cards[i].type !== 'MPC') {
        const index = MPCCards.findIndex((c) => c.id === cards[i].idMpc);
        if (index !== -1) {
          let communityList = MPCCards[index].communityCards || [];
          const cindex = communityList.findIndex((c) => c.id === cards[i].id);
          if (cindex === -1) communityList.push(cards[i]);
          MPCCards[index].communityCards = communityList;
        } else {
          MPCCards.push(cards[i]);
        }
      }
    }
    return MPCCards;
  }
  return cards;
};

const groupCommunitiesMPC = (cards, sort, country, idList) => {
  if (cards.length > 0) {
    let newCommunitiesList = [];
    let position = 0;
    for (let i = 0; i < cards.length; i++) {
      if (cards[i].type === 'MPC') {
        let MPCCard = cards[i];
        const MPCCommunities = cards[i].communityCards;
        MPCCard.communityCards = sortResults(
          MPCCommunities,
          sort,
          'community',
          country,
          idList,
        );
        newCommunitiesList.push({
          type: 'MPC',
          value: [MPCCard],
        });
        position = newCommunitiesList.length;
      } else {
        if (newCommunitiesList[position]) {
          newCommunitiesList[position].value.push(cards[i]);
        } else {
          newCommunitiesList.push({
            type: 'Community',
            value: [],
          });
          newCommunitiesList[position].value.push(cards[i]);
        }
      }
    }
    return newCommunitiesList;
  }
  return cards;
};

const SearchList = ({
  searchTitle,
  searchSubtitle,
  cardsResult,
  isMapShow,
  sort = '',
  metroCommunityDefaultSort = '',
  noAvailableNumber,
  favoritesScreen,
  rendering,
  favoritesList,
  saveFavorite,
  deleteFavorite,
  tooltipText,
  productType,
  selectedProduct,
  country,
  quickStartHomesTooltip,
  mortgageAmounts = [],
  priceDifferentialText,
  idList,
  hideMarketPromoComponent = false,
}) => {
  const breakpoint = useBreakpoint(
    typeof window !== 'undefined' && window.innerWidth,
  );
  const isMobile = ['sm', 'xs', 'md'].includes(breakpoint);
  const { metroSearchMarketPromotionCard } =
    useMetroSearchMarketPromotionCard();

  const MPCCards =
    productType === 'community'
      ? cardsResult.filter((c) => c.type === 'MPC')
      : [];
  const orderCardsByMPCAndCommunity =
    productType === 'community'
      ? getMPCsAndCommunities(cardsResult, MPCCards)
      : [];

  const sortedCards = sortResults(
    productType === 'community' ? orderCardsByMPCAndCommunity : cardsResult,
    sort !== ''
      ? sort
      : productType === 'community'
      ? metroCommunityDefaultSort
      : sort,
    productType,
    country,
    idList,
  );
  const communitySortedCards =
    productType === 'community'
      ? groupCommunitiesMPC(
          sortedCards,
          sort ? sort : metroCommunityDefaultSort,
          country,
          idList,
        )
      : sortedCards;
  const isPromotionInlineWithCards =
    productType === 'community' &&
    !isMapShow &&
    !isMobile &&
    communitySortedCards &&
    communitySortedCards.length > 0 &&
    communitySortedCards[0].type !== 'MPC';
  const beforeBanner = !favoritesScreen ? sortedCards : sortedCards.slice(0, 4);
  const afterBanner = !favoritesScreen ? [] : sortedCards.slice(4);

  useEffect(() => {
    setTimeout(() => {
      const e = document.getElementById('SearchResultList');
      // console.log(e);
      if (e) {
        e.scrollIntoView({
          block: 'start',
          behavior: 'smooth',
          inline: 'start',
        });
      }
    }, 500);
  }, []);

  return (
    <div
      className={cx('w-full pb-20', { 'pr-5': !favoritesScreen })}
      id={'SearchResultList'}
    >
      {searchTitle && (
        <SearchTitle
          key={productType + searchTitle}
          data-aos='fade-up'
          data-aos-anchor='header'
          className='text-mattamy-blue font-trade-gothic-20 text-3xl leading-9 md:text-4xl pt-6'
        >
          {searchTitle}
        </SearchTitle>
      )}
      {!noAvailableNumber && (
        <SearchSubtitle
          key={productType + searchSubtitle}
          data-aos='fade-up'
          data-aos-anchor='header'
          data-aos-delay='100'
          className='text-mattamy-blue-light font-graphie text-base pb-8 md:pb-4'
          role='status'
        >
          {searchSubtitle}
        </SearchSubtitle>
      )}
      <ListContainer trigger={cardsResult}>
        <div
          className={cx('gap-x-5 flex flex-col', {
            'md:grid md:grid-cols-2':
              (!(productType === 'community') && !isMapShow) || favoritesScreen,
          })}
        >
          {!favoritesScreen && (
            <>
              {!isPromotionInlineWithCards &&
                metroSearchMarketPromotionCard &&
                !hideMarketPromoComponent && (
                  <PromotionSearchCard
                    promotion={metroSearchMarketPromotionCard}
                  />
                )}
              {productType === 'community'
                ? communitySortedCards &&
                  communitySortedCards.map((item, index) => (
                    <>
                      {item.type === 'MPC' ? (
                        <>
                          <div
                            className={
                              'bg-light-blue rounded text-white font-graphie mb-8'
                            }
                          >
                            <div
                              className={'bg-action-blue  rounded-t mb-8 p-6'}
                            >
                              <div
                                className={
                                  'flex flex-row justify-between items-center'
                                }
                              >
                                <div
                                  className={'font-trade-gothic-20 text-3xl'}
                                >
                                  {item.value[0].title}
                                </div>
                                {!isMobile && (
                                  <a
                                    className={'border-2 py-3 px-6 rounded-md '}
                                    href={item.value[0].url}
                                    aria-label={'Learn More'}
                                  >
                                    {'Learn More'}
                                  </a>
                                )}
                              </div>
                              {isMobile && (
                                <div className={'flex my-4'}>
                                  <a
                                    className={
                                      'border-2 py-3 px-6 rounded-md w-full text-center'
                                    }
                                    href={item.value[0].url}
                                    aria-label={'Learn More'}
                                  >
                                    {'Learn More'}
                                  </a>
                                </div>
                              )}

                              <div className={'my-4'}>{item.value[0].copy}</div>
                            </div>

                            <div
                              className={cx('gap-x-5 mx-4', {
                                'md:grid md:grid-cols-2': !isMapShow,
                              })}
                            >
                              {item.value[0] &&
                                item.value[0].communityCards &&
                                item.value[0].communityCards.map(
                                  (ccs, index) => (
                                    <SearchCard
                                      key={ccs.id + index}
                                      {...ccs}
                                      favoritesList={favoritesList}
                                      saveFavorite={saveFavorite}
                                      deleteFavorite={deleteFavorite}
                                      isFavoriteCard={favoritesScreen}
                                      tooltipText={tooltipText}
                                      selectedProduct={selectedProduct}
                                      country={country}
                                      mortgageAmountsModal={mortgageAmounts.find(
                                        (e) => e.market === ccs.metro,
                                      )}
                                      priceDifferentialText={
                                        priceDifferentialText
                                      }
                                    />
                                  ),
                                )}
                            </div>
                          </div>
                        </>
                      ) : (
                        <div
                          className={cx('gap-x-5 mx-4', {
                            'md:grid md:grid-cols-2': !isMapShow,
                          })}
                        >
                          {index === 0 &&
                            isPromotionInlineWithCards &&
                            metroSearchMarketPromotionCard &&
                            !hideMarketPromoComponent && (
                              <PromotionSearchCard
                                promotion={metroSearchMarketPromotionCard}
                              />
                            )}
                          {item.value &&
                            item.value.length > 0 &&
                            item.value.map((item, index) => (
                              <div
                                className={'mx-4 flex h-full'}
                                key={item.id + index}
                              >
                                {item.type !== 'MPC' && (
                                  <SearchCard
                                    key={item.id + index}
                                    {...item}
                                    favoritesList={favoritesList}
                                    saveFavorite={saveFavorite}
                                    deleteFavorite={deleteFavorite}
                                    isFavoriteCard={favoritesScreen}
                                    tooltipText={tooltipText}
                                    selectedProduct={selectedProduct}
                                    country={country}
                                    mortgageAmountsModal={mortgageAmounts.find(
                                      (e) => e.market === item.metro,
                                    )}
                                    priceDifferentialText={
                                      priceDifferentialText
                                    }
                                  />
                                )}
                              </div>
                            ))}
                        </div>
                      )}
                    </>
                  ))
                : beforeBanner.map((item, index) => (
                    <SearchCard
                      key={item.id + index}
                      {...item}
                      favoritesList={favoritesList}
                      saveFavorite={saveFavorite}
                      deleteFavorite={deleteFavorite}
                      isFavoriteCard={favoritesScreen}
                      tooltipText={tooltipText}
                      selectedProduct={selectedProduct}
                      country={country}
                      quickStartHomesTooltip={quickStartHomesTooltip}
                      mortgageAmountsModal={mortgageAmounts.find(
                        (e) => e.market === item.metro,
                      )}
                      priceDifferentialText={priceDifferentialText}
                    />
                  ))}
            </>
          )}
        </div>
      </ListContainer>

      {favoritesScreen && (
        <div
          className={cx('gap-x-5', {
            'flex flex-col': isMapShow,
            'md:grid md:grid-cols-2': !isMapShow,
          })}
        >
          {beforeBanner.map((c, index) => (
            <SearchCard
              key={c.id + index}
              {...c}
              favoritesList={favoritesList}
              saveFavorite={saveFavorite}
              deleteFavorite={deleteFavorite}
              isFavoriteCard={favoritesScreen}
              tooltipText={tooltipText}
              quickStartHomesTooltip={quickStartHomesTooltip}
              selectedProduct={selectedProduct}
              country={country}
              mortgageAmountsModal={
                mortgageAmounts && mortgageAmounts.length > 0
                  ? mortgageAmounts.find((e) => e.market === c.metro)
                  : null
              }
              priceDifferentialText={priceDifferentialText}
            />
          ))}
        </div>
      )}

      {favoritesScreen && beforeBanner.length >= 3 && (
        <Placeholder name='inner-bar' rendering={rendering} favoritesBanner />
      )}
      <div
        className={cx('gap-x-5', {
          'flex flex-col': isMapShow,
          'md:grid md:grid-cols-2': !isMapShow,
        })}
      >
        {afterBanner.map((c, index) => (
          <SearchCard
            key={c.id + index}
            {...c}
            favoritesList={favoritesList}
            saveFavorite={saveFavorite}
            deleteFavorite={deleteFavorite}
            isFavoriteCard={favoritesScreen}
            tooltipText={tooltipText}
            quickStartHomesTooltip={quickStartHomesTooltip}
            selectedProduct={selectedProduct}
            country={country}
            mortgageAmountsModal={mortgageAmounts.find(
              (e) => e.market === c.metro,
            )}
            priceDifferentialText={priceDifferentialText}
          />
        ))}
      </div>
    </div>
  );
};

export default SearchList;
